// Auto-generated file.
// Don't edit/delete it manually!

import type {ComponentProps, ComponentType} from 'react';
import React, {forwardRef} from 'react';

const EXCEL = forwardRef((props, ref) => {
    return (
        
<svg {...props} version="1.1" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
<path fill="#fff" d="M6.938 2.25h3.75v6.75h-3.75z"></path>
<path fill="#007339" d="M10.888 1.297h-3.965v1.292h1.311v0.879h-1.31v0.859h1.298v0.865h-1.298v0.866h1.298v0.865h-1.298v0.865h1.298v0.865h-1.298v1.298h3.965c0.201-0.005 0.362-0.169 0.362-0.37 0-0.002-0-0.004-0-0.006v-7.899c0-0.002 0-0.004 0-0.006 0-0.202-0.161-0.366-0.362-0.37zM10.385 8.654h-1.732v-0.865h1.731v0.865zM10.385 6.923h-1.732v-0.865h1.731v0.865zM10.385 5.192h-1.732v-0.865h1.731v0.865zM10.385 3.461h-1.732v-0.865h1.731v0.865zM0 1.25l6.49-1.25v11.25l-6.49-1.25v-8.75zM4.106 7.823h1.17l-1.35-2.21 1.313-2.173h-1.099l-0.697 1.302c-0.067 0.169-0.113 0.296-0.137 0.382h-0.013c-0.038-0.143-0.083-0.266-0.137-0.384l-0.62-1.3h-1.202l1.278 2.192-1.397 2.191h1.178l0.757-1.415c0.053-0.136 0.086-0.238 0.101-0.306h0.012c0.030 0.143 0.060 0.24 0.088 0.294l0.755 1.427z"></path>
<path fill="#fff" d="M4.106 7.822l-0.755-1.426c-0.038-0.085-0.069-0.183-0.087-0.286l-0.013-0.008c-0.014 0.068-0.048 0.17-0.101 0.306l-0.757 1.415h-1.176l1.397-2.192-1.278-2.192h1.201l0.626 1.314c0.049 0.104 0.092 0.227 0.131 0.37h0.013c0.024-0.085 0.071-0.213 0.137-0.382l0.697-1.301h1.1l-1.314 2.172 1.351 2.21h-1.17z"></path>
</svg>

    );
}) as ComponentType<ComponentProps<'svg'>>;

export default EXCEL;
